<template>
  <nav class="app-nav-container" v-click-outside="collapseMainNav">
    <div class="nav-toggle" v-on:click="toggleMainNav">
      <div></div>
      <div></div>
      <div></div>
    </div>
    <transition name="nav-slide">
      <ul v-if="isMainNavToggled" class="app-nav" @click="collapseMainNav">
        <li
          v-for="(link) in mainLinks"
          :key="link.name"
          class="page-nav"
        >
          <router-link :to="{name: link.redirectTo}" :style="linksStyle(link)">
            <va-button v-if="link.isButton" type="submit" :style="'margin: unset'">{{link.name}}</va-button>
            <span v-else>
              {{ link.name }}
            </span>
          </router-link>
        </li>
      </ul>
    </transition>
  </nav>
</template>

<script>
export default {
  name: 'unauth-dropdown',
  data () {
    return {
      isShown: false,
      isMainNavToggled: false,
      mainLinks: [
        {
          name: 'Home',
          redirectTo: 'home',
          isButton: false,
        },
        {
          name: 'About',
          redirectTo: 'about',
          isButton: false,
        },
        {
          name: 'Services',
          redirectTo: 'all-services',
          isButton: false,
        },
        {
          name: 'Relaxation Protocol',
          redirectTo: 'relaxation-protocol',
          isButton: false,
        },
        {
          name: 'Contact',
          redirectTo: 'contact',
          isButton: false,
        },
        // {
        //   name: 'Login',
        //   redirectTo: 'login',
        //   isButton: true,
        // },
      ],
    }
  },
  methods: {
    toggleMainNav: function () {
      this.isMainNavToggled = !this.isMainNavToggled
    },
    collapseMainNav: function () {
      if (this.isMainNavToggled) {
        this.isMainNavToggled = false
      }
    },
    linksStyle (link) {
      const style = {
        color: this.$themes.gray,
      }
      if (this.$router.currentRoute.name === link.redirectTo ||
        this.$route.path.includes(link.redirectTo)) {
        style['font-weight'] = 600
        style.color = this.$themes.primary
      }
      return style
    },
  },
}
</script>

<style scoped lang="scss">
.app-nav-container {
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  margin-left: auto;
  text-transform: uppercase;

  .nav-toggle {
    width: 2.4rem;
    margin-right: 0.8rem;
    cursor: pointer;

    & > div {
      width: 100%;
      height: 0.2rem;
      border-radius: 1rem;
      background-color: $gray;

      &:not(:first-child) {
        margin-top: 0.4rem;
      }
    }
  }

  ul.app-nav {
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 70vw;
    padding: 1.2rem 0;
    overflow: hidden;
    background-color: white;
    box-shadow: -0.8rem 0.8rem 2rem 0.1rem $gray;
    border-radius: 0.375rem;

    li.page-nav {
      width: 100%;

      a {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding: 1rem;
      }
    }

    .messages-nav-item {
      display: flex;
      align-items: center;
      margin-right: 1.6rem;
      font-size: 2rem;

      .icon-messages {
        width: 2.4rem;
        height: 2.4rem;
      }
    }
  }

  // Nav menu slide transition
  .nav-slide-enter,
  .nav-slide-leave-to {
    max-height: 0;
    opacity: 0;
  }

  .nav-slide-enter-to,
  .nav-slide-leave {
    max-height: 40rem;
    opacity: 1;
  }

  .nav-slide-enter-active {
    transition: all 0.25s linear;
  }

  .nav-slide-leave-active {
    transition: all 0.25s linear;
  }
}

@include media-breakpoint-up(lg) {
  .app-nav-container {
    display: none !important;
  }
}
</style>
